import classNames from 'classnames';
import { type ReactNode } from 'react';

interface ContentBoxProps {
    content: ReactNode;
    centerContent?: boolean;
    stackVertical?: boolean;
}

export const ContentBox = ({
    content,
    centerContent = false,
    stackVertical = false,
}: ContentBoxProps) => (
    <div className="sds_content-box__container padding__around--large">
        <div
            className={classNames('sds_content-box__content', {
                'sds_content-box__content--center': centerContent,
                'sds_content-box__content--vertical': stackVertical,
            })}
        >
            {content}
        </div>
    </div>
);
